const CARD_ITEMS = [
  {
    title: '庆余年 第二季 · 全集',
    desc: '范闲假死归来，京都各方势力蠢蠢欲动。庙堂之上风云变幻，江湖之远杀机四伏，一场更大的棋局缓缓展开。全集高清免费在线观看，一次性追完！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20court%20drama%20themed%20visual%20with%20warm%20golden%20and%20coral%20lighting%2C%20traditional%20architecture%20silhouettes%20in%20soft%20focus%2C%20cinematic%20atmosphere%20with%20rich%20textures%2C%20no%20text%20or%20logos%2C%20epic%20historical%20aesthetic&width=800&height=500&seq=card-reco-01&orientation=landscape',
  },
  {
    title: '长相思 · 全集',
    desc: '大荒之内，清水镇外。小夭与玱玹、涂山璟、相柳、赤水丰隆之间纠葛缠绕的命运，一个关于爱情与守护的虐心故事。全集上线，虐到停不下来！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20ancient%20Chinese%20drama%20visual%20with%20ethereal%20warm%20peach%20and%20golden%20tones%2C%20flowing%20fabrics%20and%20cherry%20blossom%20motifs%2C%20dreamy%20cinematic%20lighting%2C%20no%20text%20or%20logos%2C%20soft%20romantic%20atmosphere&width=800&height=500&seq=card-reco-02&orientation=landscape',
  },
  {
    title: '眼泪女王 · 全集',
    desc: '百货女王洪海仁与超市王子白贤宇，一场豪门婚姻背后的爱恨纠葛。金秀贤金智媛演技炸裂，韩剧年度口碑之作全集高清在线！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20drama%20themed%20visual%20with%20luxurious%20warm%20rose%20gold%20and%20amber%20tones%2C%20sophisticated%20modern%20interior%20silhouettes%2C%20emotional%20cinematic%20atmosphere%2C%20no%20text%20or%20logos%2C%20melodramatic%20romantic%20mood&width=800&height=500&seq=card-reco-03&orientation=landscape',
  },
  {
    title: '与凤行 · 全集',
    desc: '碧苍王沈璃与最后一位神君行止之间跨越三界的旷世情缘。赵丽颖林更新再度合作，古装仙侠巨制全集免费在线观看，燃情上演！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celestial%20fantasy%20xianxia%20drama%20visual%20with%20phoenix%20and%20cloud%20motifs%20in%20warm%20golden%20and%20coral%20hues%2C%20ethereal%20light%20beams%20and%20floating%20particles%2C%20mythical%20cinematic%20aesthetic%2C%20no%20text%20or%20logos%2C%20heavenly%20atmosphere&width=800&height=500&seq=card-reco-04&orientation=landscape',
  },
  {
    title: '墨雨云间 · 全集',
    desc: '女主为爱复仇归来，隐忍蛰伏步步为营。从闺阁弱女到位极人臣，她用自己的方式改写命运。全集上线，反转不停、爽感拉满！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20elegant%20drama%20visual%20with%20ink%20wash%20painting%20inspired%20composition%2C%20dark%20charcoal%20and%20coral%20accent%20tones%2C%20rain%20and%20mist%20atmosphere%2C%20cinematic%20suspense%20aesthetic%2C%20no%20text%20or%20logos%2C%20intense%20dramatic%20mood&width=800&height=500&seq=card-reco-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            编辑精选的高分电视剧全集，每一部都值得追
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARD_ITEMS.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium">
                    推荐
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-foreground-900 text-base group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {CARD_ITEMS.slice(3).map((item) => (
            <div
              key={item.title}
              className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all overflow-hidden cursor-pointer"
            >
              <div className="w-full sm:w-48 shrink-0">
                <div className="relative h-36 sm:h-full overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <h3 className="font-heading text-foreground-900 text-base group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}